/*
  cart-external-sync.js

  Keeps the theme mini-cart (count + right drawer) in sync when an item is
  added to the cart by something OTHER than the theme's own add-to-cart flow
  — e.g. the Candy Rack cross-sell popup. Those apps POST to /cart/add
  directly and never fire the theme's `shapes:modalcart:afteradditem` event,
  so the drawer never opens and the cart count only updates on reload.

  Strategy: patch fetch + XHR, detect a successful POST to /cart/add, then
  fetch the cart sections and dispatch the same event the theme uses. The
  theme's own adds already dispatch that event, so we skip those (guarded by
  a recent-dispatch timestamp) to avoid double handling.
*/
(function () {
  if (window.__shapesCartExternalSync) return;
  window.__shapesCartExternalSync = true;

  var SECTIONS = 'cart-items,cart-footer,cart-item-count';
  var lastThemeDispatch = 0;
  var debounceTimer = null;

  function bindGuard() {
    document.body.addEventListener('shapes:modalcart:afteradditem', function (e) {
      // Ignore our own re-dispatch; only track the theme's native ones.
      if (e && e.detail && e.detail.__externalSync) return;
      lastThemeDispatch = Date.now();
    });
  }
  if (document.body) bindGuard();
  else document.addEventListener('DOMContentLoaded', bindGuard);

  function refreshCartUI() {
    // The theme already handled this add (its quick-buy / PDP flow opened and
    // refreshed the drawer itself) — don't do it twice.
    if (Date.now() - lastThemeDispatch < 2000) return;

    fetch(window.location.pathname + '?sections=' + SECTIONS, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!sections || !sections['cart-item-count']) return;
        document.body.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem', {
          bubbles: true,
          detail: { __externalSync: true, response: { sections: sections } }
        }));
      })
      .catch(function () {});
  }

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    // Debounce so multiple near-simultaneous adds (e.g. accepting an upsell)
    // collapse into a single refresh.
    debounceTimer = setTimeout(refreshCartUI, 400);
  }

  function isCartAdd(url) {
    if (!url) return false;
    try { return String(url).indexOf('/cart/add') !== -1; } catch (e) { return false; }
  }

  // --- patch fetch ---
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method) || 'GET';
      var promise = nativeFetch.apply(this, arguments);
      if (isCartAdd(url) && String(method).toUpperCase() === 'POST') {
        promise.then(function (res) { if (res && res.ok) schedule(); }).catch(function () {});
      }
      return promise;
    };
  }

  // --- patch XMLHttpRequest ---
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__syncMethod = method;
    this.__syncUrl = url;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isCartAdd(xhr.__syncUrl) && String(xhr.__syncMethod).toUpperCase() === 'POST') {
      xhr.addEventListener('loadend', function () {
        if (xhr.status >= 200 && xhr.status < 300) schedule();
      });
    }
    return nativeSend.apply(this, arguments);
  };
})();
